import React from "react";

import { useIntl } from "react-intl";

import * as Sticker from "ds/Sticker";

import * as S from "./FailedActivitySticker.style";

const FailedActivitySticker = ({ url }: { url: string }) => {
  const intl = useIntl();
  return (
    <S.FailedActivityStickerRoot priority="normal">
      <Sticker.Icon priority="normal" />
      <Sticker.Text>
        <S.StickerContent>
          {intl.formatMessage(
            {
              id: "overview.failed_activity"
            },
            {
              link: chunks => <S.Button to={url}>{chunks}</S.Button>
            }
          )}{" "}
        </S.StickerContent>
      </Sticker.Text>
    </S.FailedActivityStickerRoot>
  );
};

export default FailedActivitySticker;
